import React, { useState } from 'react'
import eventData from './data/eventCategories.json'
import './style.css'

const EventSection2 = (props) => {
    const [activeAccordion, setActiveAccordion] = useState(0);
    const [modalEvent, setModalEvent] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    // Function to dynamically import images from src folder
    const getImageSrc = (imagePath) => {
        // Check if it's a src folder image path
        if (imagePath.includes('/images/event/')) {
            const pathParts = imagePath.split('/');
            const imageName = pathParts.pop(); // Get filename
            
            // Check for different subfolders
            if (imagePath.includes('/images/event/awareness/')) {
                try {
                    return require(`../../images/event/awareness/${imageName}`);
                } catch (error) {
                    console.warn(`Awareness image not found: ${imagePath}`);
                    return imagePath;
                }
            } else if (imagePath.includes('/images/event/nature/')) {
                try {
                    return require(`../../images/event/nature/${imageName}`);
                } catch (error) {
                    console.warn(`Nature image not found: ${imagePath}`);
                    return imagePath;
                }
            } else if (imagePath.includes('/images/event/society/')) {
                try {
                    return require(`../../images/event/society/${imageName}`);
                } catch (error) {
                    console.warn(`Society image not found: ${imagePath}`);
                    return imagePath;
                }
            } else if (imagePath.includes('/images/event/health/')) {
                try {
                    return require(`../../images/event/health/${imageName}`);
                } catch (error) {
                    console.warn(`Health image not found: ${imagePath}`);
                    return imagePath;
                }
            } else if (imagePath.includes('/images/event/street/')) {
                try {
                    return require(`../../images/event/street/${imageName}`);
                } catch (error) {
                    console.warn(`Street image not found: ${imagePath}`);
                    return imagePath;
                }
            }
        }
        return imagePath; // For public folder images
    };

    const toggleAccordion = (index) => {
        setActiveAccordion(activeAccordion === index ? null : index);
    };

    const openModal = (event) => {
        setModalEvent(event);
        setCurrentImageIndex(0);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalEvent(null);
        setCurrentImageIndex(0);
    };

    const nextImage = () => {
        if (modalEvent && modalEvent.gallery) {
            setCurrentImageIndex((prevIndex) => 
                prevIndex === modalEvent.gallery.length - 1 ? 0 : prevIndex + 1
            );
        }
    };

    const prevImage = () => {
        if (modalEvent && modalEvent.gallery) {
            setCurrentImageIndex((prevIndex) => 
                prevIndex === 0 ? modalEvent.gallery.length - 1 : prevIndex - 1
            );
        }
    };

    const goToImage = (index) => {
        setCurrentImageIndex(index);
    };

    // Use event categories directly from JSON data
    const eventCategories = eventData.eventCategories;

    return(
        <div className="wpo-event-area wpo-event-area2 section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="wpo-section-title">
                            <h2>Activities and Events</h2>
                        </div>
                    </div>
                </div>
                
                <div className="accordion-container">
                    {eventCategories.map((category, index) => (
                        <div key={index} className="accordion-item">
                            <div 
                                className={`accordion-header ${activeAccordion === index ? 'active' : ''}`}
                                onClick={() => toggleAccordion(index)}
                            >
                                <h3>{category.title}</h3>
                                <span className="accordion-icon">
                                    {activeAccordion === index ? '−' : '+'}
                                </span>
                            </div>
                            
                            <div className={`accordion-content ${activeAccordion === index ? 'active' : ''}`}>
                                <div className="row">
                                    {category.events.map((event, eventIndex) => (
                                        <div key={eventIndex} className="col-lg-4 col-md-6 col-sm-12 col-12 custom-grid">
                                            <div className="simple-event-card" onClick={() => openModal(event)}>
                                                <div className="event-image">
                                                    <img src={getImageSrc(event.img)} alt={event.title}/>
                                                    <div className="event-overlay">
                                                        <i className="fa fa-search-plus"></i>
                                                        <span>View Gallery</span>
                                                    </div>
                                                </div>
                                                <div className="event-content">
                                                    <h3>{event.title}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Modal */}
                {isModalOpen && modalEvent && (
                    <div className="activity-modal" onClick={closeModal}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                            <button className="modal-close" onClick={closeModal}>
                                <i className="fa fa-times"></i>
                            </button>
                            
                            <div className="modal-header">
                                <h3>{modalEvent.title}</h3>
                            </div>

                            <div className="image-carousel">
                                <div className="carousel-container">
                                    <button className="carousel-btn prev-btn" onClick={prevImage}>
                                        <i className="fa fa-chevron-left"></i>
                                    </button>
                                    
                                    <div className="carousel-image">
                                        <img 
                                            src={getImageSrc(modalEvent.gallery[currentImageIndex])} 
                                            alt={`${modalEvent.title} - ${currentImageIndex + 1}`}
                                        />
                                    </div>
                                    
                                    <button className="carousel-btn next-btn" onClick={nextImage}>
                                        <i className="fa fa-chevron-right"></i>
                                    </button>
                                </div>

                                <div className="carousel-indicators">
                                    {modalEvent.gallery.map((_, index) => (
                                        <button
                                            key={index}
                                            className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                                            onClick={() => goToImage(index)}
                                        />
                                    ))}
                                </div>

                                <div className="carousel-counter">
                                    {currentImageIndex + 1} / {modalEvent.gallery.length}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default EventSection2;